<template>
    <b-modal
        :active.sync="_active"
        :canCancel="['escape', 'x']"
        class="modal-box common-modal"
        :width="width"
        @close="cancel"
    >
        <div ref="wrapper" class="modal-box-wrapper">
            <div ref="header" class="modal-box-header">{{ headerText }}</div>
            <div class="modal-box-adder-wrapper">
                <slot />
            </div>
            <div class="buttons-wrapper" v-if="hasButtons">
                <div class="buttons-wrapper__inner">
                    <button
                        class="cancel"
                        v-if="hasCancelBtn"
                        @mousedown.stop
                        @click="cancel"
                    >
                        {{ cancelText }}
                    </button>
                    <button
                        class="confirm"
                        @mousedown.stop
                        @click="confirm"
                        v-if="hasConfirmBtn"
                    >
                        {{ confirmText }}
                    </button>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        headerText: {
            type: String,
            default: '',
        },
        confirmText: {
            type: String,
            default: 'OK',
        },
        cancelText: {
            type: String,
            default: 'CANCEL',
        },
        hasButtons: {
            type: Boolean,
            default: true,
        },
        hasConfirmBtn: {
            type: Boolean,
            default: true,
        },
        hasCancelBtn: {
            type: Boolean,
            default: true,
        },
        width: {
            type: String,
            default: '450px',
        },
    },
    computed: {
        _active: {
            get: R.prop('active'),
            set(value) {
                this.$emit('update:active', value);
            },
        },
    },
    components: {},
    methods: {
        confirm() {
            this.$emit('confirm', this.values);
        },
        cancel() {
            this._active = false;
            this.$emit('cancel');
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-box-wrapper {
    // position: fixed;
    background-color: white;
    border-radius: 10px;
    width: 100%;
    min-width: 450px;
    @media screen and (max-width: 767px) {
        max-width: 90vw;
        min-width: 80vw;
        margin: 0 auto;
    }
    .buttons-wrapper {
        margin-top: 30px;
        padding: 0 15px 15px 15px;
        &__inner {
            display: flex;
            justify-content: space-between;
            margin: 0 -7.5px;
            @media screen and (max-width: 767px) {
                button {
                    flex: 1;
                    width: auto;
                }
            }
            button {
                width: 205px;
                font-size: 18px;
                font-weight: bold;
                color: white;
                border-radius: 5px;
                height: 50px;
                flex: 1;
                width: auto;
                margin: 0 7.5px;

                &.cancel {
                    background-color: $color4;
                }

                &.confirm {
                    background-color: $color21;
                }
            }

            span {
                text-align: center;
                font-size: 16px;
                color: $color12;
            }
        }
    }
}

.modal-box-editable-box {
    max-height: calc(400px - 95px);
    overflow-y: auto;
}

.modal-box-header {
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #ddd;
    background-color: #f7f7f7;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 45px;
    font-weight: bold;

    & + .modal-box-adder-wrapper {
        padding: 15px;
        padding-bottom: 0px;

        .modal-box-divider {
            margin-top: 15px;
        }
    }
}

.modal-box-channels {
    padding: 15px;
}
.modal-box-editable-body {
    margin-top: 15px;
}
.modal-box-adder {
    display: flex;
    align-items: center;

    &:not(.async-search) {
        img {
            margin-left: 10px;
            cursor: pointer;
        }
    }
}

.modal-box-divider {
    width: 100%;
    height: 1px;
    background-color: $color5;
}
</style>

<style lang="scss">
.modal-box.common-modal {
    .modal-content {
        width: auto;
    }
}

.modal-box-wrapper {
    .modal-box-adder {
        display: flex;
        align-items: center;

        .control {
            width: 100%;
            input.input {
                border: none;
                box-shadow: none;
                height: 28px;
                background-color: $color13;
                font-size: 14px;
                font-weight: 500;
                color: white;
                width: 100%;

                &::-webkit-input-placeholder {
                    color: rgba(255, 255, 255, 0.5);
                }
                &::-moz-placeholder {
                    color: rgba(255, 255, 255, 0.5);
                }
                &:-moz-placeholder {
                    color: rgba(255, 255, 255, 0.5);
                }
            }
        }

        &.async-search {
            position: relative;
            .autocomplete + img {
                position: absolute;
                right: 10px;
                cursor: pointer;
            }
            .control {
                input.input {
                    background-color: $color14;
                    border: 1px solid $color5;
                    color: $color7;

                    &::-webkit-input-placeholder {
                        color: $color4;
                    }
                    &::-moz-placeholder {
                        color: $color4;
                    }
                    &:-moz-placeholder {
                        color: $color4;
                    }
                }
            }
        }
    }
    .modal-box-checkable {
        display: flex;
        align-items: center;
        cursor: pointer;
        &.specific-sites {
            padding: 15px 15px 10px 15px;

            & > span {
                font-size: 12px;
                font-weight: bold;
                color: $color9;
            }

            & + .modal-box-adder-wrapper {
                padding: 0 15px 0 45px;
            }
        }

        &.checkable-checked {
            .journey-editable-element {
                border: 2px solid $color21;
            }
        }

        & > img {
            margin-right: 10px;
        }

        .journey-editable-input-wrapper {
            width: 100%;
        }
    }
}
</style>
